var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_redefine-all.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_redefine-all.js
// module chunks = 0